import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { get } from '../Services/http';

const RenderPrivateOrBusinessFooterSelector = () => {
    const dispatch = useDispatch();
    const [showPriceWithVatValue, setShowPriceWithVatValue] = useState();
    const [dataReady, setDataReady] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const incVat = document.getElementById('footer').getAttribute('data-including-vat');
            if (incVat == "True") {
                setShowPriceWithVatValue(true);
            } else {
                setShowPriceWithVatValue(false);
            }          
            setDataReady(true);
        };
        fetchData();
    }, []);

    const showPrivate = () => {
        setShowPriceWithVatValue(true)
        onSelect(true)
    }

    const showBusiness = () => {
        setShowPriceWithVatValue(false)
        onSelect(false)
    }

    const onSelect = (type) => {
        get(`/api/v1/setCustomerType?useVat=${type}`).then(() =>
            window.location.reload()
        );
    };

    return (
        <>
            {dataReady && (
                <Fragment>
                    <a onClick={() => showPrivate()} className={showPriceWithVatValue ? "vatSelectorReduce" : "vatSelectorHighlight"} aria-disabled={showPriceWithVatValue}>
                        {translate('checkout.private')}
                    </a>
                    <span> | </span>
                    <a onClick={() => showBusiness()} className={showPriceWithVatValue ? "vatSelectorHighlight" : "vatSelectorReduce"} aria-disabled={!showPriceWithVatValue}>
                        {translate('checkout.company')}
                    </a>
                </Fragment>
            )}
        </>
    );
};

export default RenderPrivateOrBusinessFooterSelector;
